import { PlayerLocality } from '../../types/player';


export const playerLocalityToSortOrder: Record<PlayerLocality, number> = {
  'local': 5,
  'national': 4,
  'international': 3,
};


export const playerLocalities: PlayerLocality[] = [
  'local',
  'national',
  'international',
];
